import { default as Box } from '@mui/material/Box';
import { SxProps } from '@mui/system/styleFunctionSx';
import { BoldLabel, LightGrayLabel } from 'components/labels';

export const DetailsDataItem = ({
  label,
  value,
  sx
}: {
  label: string;
  value: string | number;
  sx?: SxProps;
}) => (
  <Box sx={{ pb: 2, ...sx }}>
    <BoldLabel>{label}</BoldLabel>
    <LightGrayLabel variant="body2">{value}</LightGrayLabel>
  </Box>
);
